import type { User } from "@/entities/user/types/user";

export type { User } from "@/entities/user/types/user";
export const displayUserName = <T extends Pick<User, "firstName" | "lastName">>(
  user: T,
): string => {
  return `${user.firstName}${user.lastName ? " " + user.lastName : ""}`;
};
